// SpecialLeaveTab.tsx  (top of the file)
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import * as yup from 'yup';

const t = i18n.getFixedT(getLocale(), 'common', 'adminPortal.cla');

const norm = (s?: string) => s?.trim().toLowerCase() ?? '';

const makeUniqueFteTest = (list: string[]) =>
  yup
    .string()
    .trim()
    .test(
      'unique-fte',
      t('specialLeave.settings.errors.duplicateImportCode', {
        code: '${value}'
      }),
      function (value) {
        if (!value) return true;
        const hits = list.filter((c) => c === norm(value)).length;
        return hits <= 1; // allow the field’s own single occurrence
      }
    );

export const buildSaveSchema = (list: string[]) =>
  yup.object({
    specialLeaveFteLeaveHoursImportCode: makeUniqueFteTest(list),
    specialLeaveFtePlbHoursImportCode: makeUniqueFteTest(list),
    specialLeaveFteHolidayCompensationImportCode: makeUniqueFteTest(list)
  });

export const addRowSchema = yup.object({
  specialLeaveImportCode: yup
    .string()
    .trim()
    .required(t('errors.required'))
    .test(
      'unique-import-code',
      t('specialLeave.settings.errors.duplicateImportCode', {
        code: '${value}'
      }),
      function (value) {
        // All already-taken codes are passed in through `context`
        const { existingImportCodes = [] } = this.options.context || {};
        if (!value) return true; // handled by .required()
        return !existingImportCodes.includes(value.toLowerCase());
      }
    ),

  specialLeaveDutyHourTypeId: yup
    .number()
    .typeError(t('errors.required'))
    .required(t('errors.required')),
  specialLeavePercentage: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' ? undefined : value
    )
    .typeError(t('errors.invalidNumber'))
    .nullable()
    .notRequired()
});
